var exports = {
  "kL": "BaseAvatar.module__container___WVJzdU",
  "vk": "BaseAvatar.module__clickable___WVJzdU",
  "Lw": "BaseAvatar.module__overlay___WVJzdU",
  "Sl": "BaseAvatar.module__image___WVJzdU",
  "qf": "BaseAvatar.module__placeholder___WVJzdU",
  "ci": "BaseAvatar.module__placeholderFastFade___WVJzdU",
  "Ap": "BaseAvatar.module__placeholderVisible___WVJzdU",
  "uR": "BaseAvatar.module__placeholderHidden___WVJzdU",
  "n_": "BaseAvatar.module__hoverOverlay___WVJzdU",
  "II": "BaseAvatar.module__statusContainer___WVJzdU",
  "mH": "BaseAvatar.module__statusTooltipDisabled___WVJzdU",
  "VN": "BaseAvatar.module__reducedMotion___WVJzdU",
  "BC": "BaseAvatar.module__animatedMaskShape___WVJzdU",
  "Qb": "BaseAvatar.module__animatedMaskReducedMotion___WVJzdU",
  "AP": "BaseAvatar.module__typingBubble___WVJzdU",
  "y5": "BaseAvatar.module__typingDots___WVJzdU",
  "BI": "BaseAvatar.module__typingDot___WVJzdU",
  "fQ": "BaseAvatar.module__customStatusBadge___WVJzdU",
  "Bp": "BaseAvatar.module__customStatusBadgeBackground___WVJzdU",
  "Go": "BaseAvatar.module__customStatusBadgeContent___WVJzdU",
};

module.exports = exports;
